import React from 'react';

export { default as reducer } from './AdvancedAnalyticsReducer';

export const AdvancedAnalyticsV2Lazy = React.lazy(() => import(/* webpackChunkName: "CBM" */ './AdvancedAnalyticsContainer'));
